const actions = {
    ERROR: 'ERROR',
    BEGIN: 'BEGIN',
    SET_VENUES: 'SET_VENUES',
    SET_VENUE_PROFILE: 'SET_VENUE_PROFILE',

    begin: () => {
        return {
            type: actions.BEGIN,
        };
    },

    error: (err) => {
        return {
            type: actions.ERROR,
            err,
        };
    },

    setVenues: (data, total) => {
        return {
            type: actions.SET_VENUES,
            data,
            total,
        };
    },

    setVenueProfile: (data) => {
        return {
            type: actions.SET_VENUE_PROFILE,
            data,
        };
    },
};

export default actions;